import { render, staticRenderFns } from "./FormUmpanBalikEkspektasiPerilaku.vue?vue&type=template&id=464b09a6&lang=html&"
import script from "./FormUmpanBalikEkspektasiPerilaku.vue?vue&type=script&lang=js&"
export * from "./FormUmpanBalikEkspektasiPerilaku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports